export class Summary
{
    service: string;
    demande: string;
}
